import { render } from "./CorporatePlanUpdate.vue?vue&type=template&id=37565e83"
import script from "./CorporatePlanUpdate.vue?vue&type=script&lang=js"
export * from "./CorporatePlanUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__